import React, { useEffect, useMemo, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/viii-lijjam-combat-de-jiu-jitsu-2025/tabela-viii-lijjam-combat-de-jiu-jitsu-2025.jpg";
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import desceGelo from "../../assets/images/sponsors/desce-gelo.jpeg";
import drGuarana from "../../assets/images/sponsors/dr-guarana.png";
import fireBoy from "../../assets/images/sponsors/fire-boy.png";
import ligaDeJiuJitsu from "../../assets/images/sponsors/liga-de-jiu-jitsu.png";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";


//Apoio
import trevusMartialArts from "../../assets/images/sponsors/trevus-martial-arts.jpg";
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, InputAdornment, TextField } from "@mui/material";
import Papa from "papaparse";

const sponsors = [
  { img: desceGelo },
  { img: drGuarana },
  { img: fireBoy },
  { img: ligaDeJiuJitsu },
  { img: torneio, url: "http://www.torneiofacil.com" },
];

const cacheBuster = `?cacheBuster=${new Date().getTime()}`
const support = [

  { img: torneio, url: "http://www.torneiofacil.com" },
];


const dataEvento = "05 de outubro de 2025 "
const horaEvento = "9:00h da manhã"
const tituloEvento = "VIII LIJJAM Combat de Jiu Jitsu Gi e Nogi"
const localEvento = "Ginásio Nininberg Guerra"
const endereçoEvento = "R. Barão do Rio Branco, 320 - São Jorge, Manaus - AM, CEP 69033-430"
const dataDeEncerramentoIncricao = "01/OUT/2025"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "01/OUT/2025"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLote1 = "05/SET/2025"
/* const dataDeEncerramentoInscricaoLote2 = "25/AGO/2025"
const dataDeEncerramentoInscricaoLote3 = "03/SET/2025"
 */

const valorinscricaoCategoriaLote1 = "70,00 (setenta reais)"
/* const valorinscricaoCategoriaLote2 = "70,00 (setenta reais)"
const valorinscricaoCategoriaLote3 = "80,00 (oitenta reais)" */
const valorinscricaoLote1ComboGieNogi = "130,00 (cento e trinta reais)"
/* const valorinscricaoLote2ComboGieNogi = "100,00 (cem reais)"
const valorinscricaoLote3ComboGieNogi = "120,00 (cento e vinte reais)" */

const valorinscricaoAbsolutoLoteUnico = "100,00 (cem reais)"
const valorinscricaoAbsolutoLote2 = "75,00 (setenta e cinco reais)"

const dataDeDivulgacaoChaves = "04/OUT/2025"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = "Bradesco"
const tipoDeChavePix = "Telefone"
const ChavePix = "(92) 99468-5161"
const BeneficiarioDaChavePix = "José Michel Tavares Pio"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "(92) 99468-5161"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "viii-lijjam-combat-de-jiu-jitsu-manaus-am-gi";
const slugNOGI = "viii-lijjam-combat-de-jiu-jitsu-manaus-am-nogi";
const rotaInscriçãoGi = `/enrollment/viii-lijjam-combat-de-jiu-jitsu-manaus-am-gi${cacheBuster}`;
const rotaChecagemGi = "/check/viii-lijjam-combat-de-jiu-jitsu-manaus-am-gi/search";
const rotaChecagemNoGi = "/check/viii-lijjam-combat-de-jiu-jitsu-manaus-am-nogi/search";
//const rotaChavesGI = "#"//"http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.DB5B8D07&u=teste"
const rotaChavesGi =
  "/tournament/keys/viii-lijjam-combat-de-jiu-jitsu-manaus-am-gi";
const rotaChavesNoGi =
  "/tournament/keys/viii-lijjam-combat-de-jiu-jitsu-manaus-am-nogi";


const ViiiLijjamCombatDeJiuJitsu2025: React.FC = () => {

  useEffect(() => {
    // Adiciona cache buster se não estiver presente
    if (!window.location.search.includes("cacheBuster")) {
      const newUrl = `${window.location.pathname}${cacheBuster}`;
      window.location.replace(newUrl); // Redireciona para a nova URL
    }
  }, []);



  const { authenticated } = useAuthenticate();
  const navigate = useNavigate();
  const [tournamentGI, setTournamentGI] = useState<any>();
  const [tournamentNOGI, setTournamentNOGI] = useState<any>();
  const [chavesModalOpen, setChavesModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState<any[]>([]);

  const normalizeKey = (key: string) =>
    key
      .replace(/\s+/g, " ")        // substitui múltiplos espaços / quebras de linha por 1 espaço
      .replace(/\n/g, " ")         // remove quebra de linha explícita
      .trim()                      // remove espaços no início/fim
      .normalize("NFD")            // remove acentos
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();              // padroniza pra minúsculas

  useEffect(() => {
    api.get(`/tournaments/${slugGI}`).then(({ data }) => {
      setTournamentGI(data);
    });

    api.get(`/tournaments/${slugNOGI}`).then(({ data }) => {
      setTournamentNOGI(data);
    });
  }, []);

  useEffect(() => {
    fetch("https://docs.google.com/spreadsheets/d/e/2PACX-1vRNFVN84QBmaq4XBDmjlgd6FTfLN2HB8iUfPR2YNGIyHpkkCE8gBoK8JNzh8pByEcIgc5MvllPJ9jwB/pub?gid=738523974&single=true&output=csv")
      .then((res) => res.text())
      .then((csvText) => {
        const parsed = Papa.parse(csvText, { header: true });
        setRows(parsed.data);
      });
  }, []);

  const handleToSubscriptionPage = (url: string) => {

    if (!tournamentGI.canSubscribe || !tournamentNOGI.canSubscribe) {
      const msg = "Período de inscrição encerrado.";

      Swal.fire({
        title: 'Atenção!',
        text: msg,
        icon: 'error',
      });

      toast.error(msg);
      return;
    }

    console.log('dasidjasiodjidsj', url);

    navigate(url, { replace: true });
    return;
  }

  // handler simples de busca
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const filteredRows = useMemo(() => {
    if (!search.trim()) return rows;

    const query = search.toLowerCase();
    const matchedIndices = new Set<number>();

    rows.forEach((row, i) => {
      const nome = Object.entries(row).find(([k]) =>
        normalizeKey(k).includes("nome")
      )?.[1];
      const academia = Object.entries(row).find(([k]) =>
        normalizeKey(k).includes("academia")
      )?.[1];
      const inscricao = Object.entries(row).find(([k]) =>
        normalizeKey(k).includes("insc")
      )?.[1];

      const textValues = [nome, academia, inscricao]
        .map((v) => String(v || "").toLowerCase())
        .join(" ");

      if (textValues.includes(query)) {
        // marca o atleta e o outro da mesma luta
        const start = i % 2 === 0 ? i : i - 1; // início do par
        matchedIndices.add(start);
        matchedIndices.add(start + 1);
      }
    });

    // monta as lutas completas (pares de linhas)
    return rows.filter((_, i) => matchedIndices.has(i));
  }, [search, rows]);

  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/viii-lijjam-combat-de-jiu-jitsu-2025/viii-lijjam-combat-de-jiu-jitsu-2025.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/viii-lijjam-combat-de-jiu-jitsu-2025/viii-lijjam-combat-de-jiu-jitsu-2025.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/vjPK4TMBK9ax2v828"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>

                  {/* <Span>
                    A {tituloEvento} é um evento tradicional  que
                    fomenta e incentiva a prática do jiu jitsu na cidade de Manaus-Am . As lutas
                    serão GI (com kimono) e NOGI (sem kimono), o evento disponibilizará
                    categorias para todas as idades e faixas, conforme as tabelas de peso
                    deste edital. Os competidores terão a oportunidade de testar suas
                    habilidades em um ambiente controlado e com acompanhamento de
                    profissionais qualificados.
                  </Span> */}

                  <Span>
                    A {tituloEvento} é um evento tradicional de LUTAS CASADAS que
                    fomenta e incentiva a prática do jiu jitsu na cidade de Manaus-Am . As lutas
                    serão GI (com kimono) e NOGI (sem kimono), o evento disponibilizará
                    categorias para todas as idades e faixas. Os competidores terão a oportunidade de testar suas
                    habilidades em um ambiente controlado e com acompanhamento de
                    profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title="PREMIAÇÕES: CINTURÃO + DINHEIRO💰">
                  <H3>Academias:</H3>
                  <P>1° lugar: R$5.000,00 </P>
                  <P>2° lugar: R$2.000,00 </P>
                  <P>3° lugar: R$1.000,00 </P>
                  <P>4° lugar: R$500,00 </P>
                  <P>5° lugar: R$500,00 </P>
                  <P>6° lugar: R$500,00 </P>
                  <P>7° lugar: R$500,00 </P>

                  <br />
                  <H3>Categorias GI e NOGI</H3>
                  <P>1° lugar: Cinturão</P>
                  <P>2° lugar: Mini Cinturão</P>
                  <br />
                  {/* <p>
                      Estas premiações só irão valer para os Absolutos GI (COM KIMONO) e NOGI (SEM KIMONO) que tiverem 08 (OITO)
                      ou mais atletas inscritos.
                    </p>
                    <p>
                      Número menor que 8 atletas a premiação ficará a critério da organização do evento, podendo não ter premiação.
                    </p>

                    <P>
                      Para a realização de lutas na categoria absoluto, é exigido um mínimo
                      de 8 atletas inscritos.
                    </P>
                    <p>
                      Mais informações sobre as inscrições para o absoluto está disponível
                      na seção INSCRIÇÕES, parágrafo Inscrição de Absoluto deste edital.
                    </p>
                    <br /> */}
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2025, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2025,
                    conforme regra da CBJJ.
                  </P>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às{' '}
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />
                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <H3>Checagem</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                  {/*  <H3>Inscrição de Absoluto</H3>
                  <P>
                    A inscrição para o absoluto será somente no dia do evento com o pagamento no valor de R$50,00.
                  </P>
                  <P>
                    Somente atletas inscritos na categoria poderão se increver e participar
                    do absoluto.
                  </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a categoria da
                    sua inscrição no torneio. Exceção apenas para os master que poderá se
                    inscrever como absoluto adulto.
                  </P>
                  <P>
                    A Premiação em dinheiro para o absoluto em primeiro lugar será definida junto a equipe de organização no dia do evento. 
                  </P> */}
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  {/*  <Span>
                    As inscrições serão divididas em três lotes:
                  </Span> 
                  <br /> */}
                  <H3>Lote 1- Pagamento até {dataDeEncerramentoInscricaoLote1}</H3>
                  <P>Inscrição GI ou NOGI categoria R$ {valorinscricaoCategoriaLote1}</P>
                  <P>Inscrição Combo GI+NOGI R$ {valorinscricaoLote1ComboGieNogi}</P>
                  <br />
                  {/* <H3>Lote 2- Pagamento até {dataDeEncerramentoInscricaoLote2}</H3>
                  <P>Inscrição GI ou NOGI categoria R$ {valorinscricaoCategoriaLote2}</P>
                  <P>Inscrição Combo GI+NOGI R$ {valorinscricaoLote2ComboGieNogi}</P>
                  <br />
                  <H3>Lote 3- Pagamento até {dataDeEncerramentoInscricaoLote3}</H3>
                  <P>Inscrição GI ou NOGI categoria R$ {valorinscricaoCategoriaLote3}</P>
                  <P>Inscrição Combo GI+NOGI R$ {valorinscricaoLote3ComboGieNogi}</P>
                  <br /> */}

                </Collapse>
                <Collapse title="PAGAMENTO">
                  <H3>
                    A baixa do pagamento será efetuada de forma automática.
                  </H3>
                  <H3>
                    É necessário completar todas as etapas até finalizar a operação de pagamento.
                  </H3>
                  {/* <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                  <p />
                  {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                    inscrição, sendo obrigatório a comprovação e apresentação de atestado
                    médico.
                  </H3>
                  <H3>
                    O valor para reembolso será de 80% do valor da inscrição.
                  </H3>
                  <H3>
                    Após o fim do período de inscrição não será possível o reembolso das
                    inscrições pagas.
                  </H3>
                </Collapse>

                <Collapse title="REGRAS">
                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  {/* <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span> */}
                  <Span>
                    As lutas serão casadas, conforme o julgamento da organização do evento.
                  </Span>
                  <Span>
                    As lutas serão GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                    As lutas serão NOGI (com roupas adequadas) devem estar limpos sem rasgos e sem odor .
                  </Span>
                  {/* <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho no sorteio da chave estará automaticamente na final.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span> */}
                  <Span>
                    A pesagem será realizada no dia do evento momentos antes da luta. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  {/*                   <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span> */}
                  {/* <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados.
                  </Span> */}

                  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                    ele lutará como Juvenil faixa Azul.
                  </Span>

                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  {/* <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span> */}
                  <Span>Teremos uma balança para pesagem oficial dos atletas.</Span>
                  <Span>A arbitragem será composta por equipe de árbitros das federações do
                    Amazonas de Jiu-Jitsu.
                  </Span>
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <Span>
                    Tolerância de 15 minutos a partir do horário marcado para a luta para a
                    decretação do W.O.

                  </Span>
                  <br />
                  <H3>Pontuação por equipe</H3>
                  <H5>Categoria , todas as faixas</H5>
                  <P>1° lugar: 3 Pontos</P>
                  <P>2° lugar: 1 Ponto</P>
                  <P>Campeão Direto: 3 Pontos</P>
                  <P>Campeão por W.O: 3 Pontos</P>
                  <br />
                  {/*  <P>
                    A organização do evento irá confeccionar um crachá para disponibilizar a apenas um representante por equipe.
                  </P>
                  <P>
                    O representante que for escolhido a usar o crachá fará todas as funções necessárias sobre sua equipe com  relação ao evento.
                  </P>
                  <P>
                    Só ficará 01 representante de cada equipe para
                    tirar todas as dúvidas e os questionamentos só serão aceito vindo do mesmo.
                  </P>
                  <P>
                    O mesmo representante de cada academia finalista subirá no pódio,
                    podendo ter em suas mão a somente a bandeira da academia que foi inscrita no evento.
                  </P>
                  <P>
                    Crianças até 11 anos, poderão ser acompanhadas em sua área de luta apenas com o representante de sua equipe.
                  </P> */}
                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as lutas GI e NOGI.
                  </P>
                  {/*  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistência do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com apenas dois atletas da mesma academia não contam pontos
                    para a disputa por academias.
                  </P> */}
                  <br />
                  {/* <H3>Para o absoluto:</H3>
                  <P>
                    Não será permitido luta combinada.
                  </P>
                  <P>
                    Não será permitido fechamento dos finalistas.
                  </P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima ,  a organização fica sem a obrigação de fazer a entrega  da premiação  citado nesse edital.
                  </P>
                  <br /> */}
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
                 

                  <Container>

                  <span>LIJJAM COMBAT 8</span>
                  <h5>09:00 - Lutas 01 a 40</h5>
                  <h5>09:30 - Lutas 41 a 80</h5>
                  <h5>10:00 - Lutas 81 a 110</h5>
                  <h5>10:30 - Lutas 111 a 140</h5>
                  <h5>11:00 - Lutas 141 a 160</h5>
                  <h5>11:30 - Lutas 161 a 190</h5>
                  <h5>12:00 - Lutas 191 a 220</h5>
                  <h5>12:30 - Lutas 221 a 250</h5>
                  <h5>13:00 - Lutas 251 a 280</h5>
                  <h5>13:30 - Lutas 281 a 300</h5>
                  <h5>14:00 - Lutas 301 a 320</h5>
                  <h5>14:30 - Lutas 321 a 340</h5>
                  <h5>15:00 - Lutas 341 a 370</h5>
                  <h5>15:30 - Lutas 371 a 400</h5>
                  <h5>16:00 - Lutas 401 a 430</h5>
                  <h5>16:30 - Lutas 431 a 460</h5>
                  <h5>17:00 - Lutas 461 a 490</h5>
                  <h5>17:30 - Lutas 491 a 520</h5>
                  <h5>18:00 - Lutas 521 a 550</h5>
                  <h5>18:30 - Lutas 551 a 580</h5>
                  <h5>19:00 - Lutas 581 a 640</h5>


                    {/*                     <br />
                    <span>CRONOGRAMA COPA MESTRE DO AÇAI 2025</span>

                    <h5>09:00 - Abertura do evento e Hino Nacional</h5>
                    <h5>09:30 - Todas as Categorias Nogi - Categorias Pré-Mirim e Mirim A - Todas as Faixas masculino/feminino</h5>
                    <h5>10:30 - Categoria Mirim B - Todas as Faixas masculino/feminino</h5>
                    <h5>11:00 - Infantil A - Todas as Faixas masculino/feminino</h5>
                    <h5>11:30 - Infantil B - Todas as faixas masculino/feminino</h5>
                    <h5>12:00 - Infanto-juvenil Todas as faixas Masculino/Feminino</h5>
                    <h5>12:30 - Juvenil - Todas as faixas masculino/feminino</h5>
                    <h5>13:00 - Faixa Branca Adulto masculino/feminino</h5>
                    <h5>13:30 - Faixa Branca Masters masculino/feminino</h5>
                    <h5>14:00 - Faixa Azul Adulto e Master Masculino e Feminino</h5>
                    <h5>14:30 - Faixa Roxa Adulto e Master Masculino e Feminino</h5>
                    <h5>15:00 - Faixas Marrom e Preta Adulto e Master Masculino e Feminino</h5>
                    <h5>15:40 - Início das Inscrições dos Absolutos</h5>
                    <h5>16:00 - Ínicio dos Absolutos</h5>
                    <h5>17:00 - Super Lutas</h5>*/}

                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      <li>O cronograma pode ser adiantado em até 30 minutos, e atrasar até 10h devido as necessidades do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 30 minutos antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss 
                  </Container>
                </Collapse>
                <Collapse title="CONTATO">
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*VIII%20LIJJAM%20COMBAT%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              {authenticated ? (
                <>
                  {/* <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi">
                    Inscrição GI
                  </TournamentEnrollmentLinkEndpage>
                  <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi">
                    Inscrição NOGI
                  </TournamentEnrollmentLinkEndpage> */}

                  <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage(rotaInscriçãoGi)}>
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              ) : (
                <>
                  <TournamentEnrollmentLinkEndpage to="" onClick={() => handleToSubscriptionPage("/login")}>
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/login">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              )}
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem GI
              </TournamentLink>

              <TournamentLink
                // target="_blank"
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink>

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              {/* <TournamentLink
                // target="_blank"
                href={rotaChavesGI}
              >
                Chaves GI e NOGI
              </TournamentLink> */}

              <TournamentLink
                // target="_blank"
                onClick={() => setChavesModalOpen(true)}
              >
                Chaves
              </TournamentLink>

              {/* <TournamentLink
                // target="_blank"
                href={rotaChavesNoGi}
              >
                Chaves NOGI
              </TournamentLink> */}

              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              {/* <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink> */}
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />

      <Dialog
        open={chavesModalOpen}
        onClose={() => setChavesModalOpen(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
          },
        }}
      >
        {/* Cabeçalho */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1,
            borderBottom: "1px solid #ddd",
          }}
        >
          <DialogTitle sx={{ m: 0, p: 0, fontWeight: "bold" }}>Chaves</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setChavesModalOpen(false)}
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Campo de busca */}
        <TextField
          fullWidth
          placeholder="Pesquisar por nome, inscrição ou academia..."
          value={search}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          size="small"
          sx={{ px: 2, py: 1 }}
        />

        {/* Conteúdo da tabela */}
        <DialogContent sx={{ p: 0, height: "80vh" }}>
          <div style={{ padding: 20 }}>
            <h3>Chaves {tituloEvento}</h3>
            <table
              border={1}
              cellPadding={6}
              style={{
                borderCollapse: "collapse",
                width: "100%",
                textAlign: "center",
              }}
            >
              <thead style={{ backgroundColor: "#f5f5f5" }}>
                <tr>
                  {rows[0] &&
                    Object.keys(rows[0]).map((key) => <th key={key}>{key}</th>)}
                </tr>
              </thead>

              <tbody>
                {filteredRows.map((row, i) => (
                  <tr key={i}>
                    {Object.entries(row).map(([key, val], j) => {
                      const normalizedKey = normalizeKey(key);

                      // coluna LUTAS mesclada (2 linhas)
                      if (normalizedKey.includes("luta") && i % 2 === 0) {
                        return (
                          <td
                            key={j}
                            rowSpan={2}
                            style={{
                              textAlign: "left",
                              verticalAlign: "middle",
                              width: 90,
                              background: "#fafafa",
                            }}
                          >
                            {String(val)}
                          </td>
                        );
                      }

                      if (normalizedKey.includes("nº insc.")) {
                        return (
                          <td
                            key={j}
                            style={{
                              textAlign: "left",
                              verticalAlign: "center",
                              width: 90
                            }}
                          >
                            {String(val)}
                          </td>
                        );
                      }

                      if (normalizedKey.includes("luta") && i % 2 !== 0) return null;

                      return (
                        <td
                          key={j}
                          style={{
                            textAlign: "left",
                            verticalAlign: "middle",
                          }}
                        >
                          {String(val)}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViiiLijjamCombatDeJiuJitsu2025;
